module.exports = __webpack_public_path__ + "static/media/cloud-snow.a227e6dc.png";